module.exports = __webpack_public_path__ + "static/media/nov.b945f921.jpg";